import styled from 'styled-components';

export const Container = styled.div`
  width: 80vw;
  max-width: 52rem;
  padding: 4.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  color: #262a3a;
  font-size: 2.4rem;
  font-weight: 700;
  text-align: center;
  /* max-width: 19rem; */
  margin-bottom: 6.7rem;
`;
